var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.417 7H15a1 1 0 1 1 0 2H3.417l4.59 4.591a1 1 0 1 1-1.414 1.416l-6.3-6.3a1 1 0 0 1 0-1.414l6.3-6.3A1.001 1.001 0 1 1 8.008 2.41z",
  clipRule: "evenodd"
})));
export default SvgBack;